// extracted by mini-css-extract-plugin
export var mainColumnCell = "main-column-cell_riknIfiDefeZJD1hgbpq";
export var mainColumnCellAdornment = "main-column-cell-adornment_DwPGTaDQ4bbbQ25YyPR9";
export var mainColumnCellLabel = "main-column-cell__label_OB3I613BqROgbL9dBEYT";
export var mainColumnCellWithAdornment = "main-column-cell-with-adornment_l1NYpCTe7HKznwuIOFX7";